import { registerRegisterDetail } from '@/features/startTask/preset_task/shared/preset/register/registerDetailRegistry';

/** B32107 — Notice for Controller (Corporate); Register of Controllers (A50009) */
const noticeCorporateControllerDetailMap = {
  title: 'New Corporate Controller Details',
  fields: [
    {
      label: 'Corporate Name',
      key: ['controller_corporate_name', 'controllerCorporateName'],
    },
    {
      label: 'UEN',
      key: ['controller_uen', 'controllerUen', 'acrAuen', 'regNo'],
    },
    {
      label: 'Registered Office',
      key: ['controller_registered_office', 'controllerRegisteredOffice'],
    },
    { label: 'Email', key: ['controller_email', 'controllerEmail'] },
    { label: 'Contact No', key: ['controller_contact_no', 'controllerContactNo'] },
    {
      label: 'Legal Form',
      key: ['controller_legal_form', 'controllerLegalForm', 'legalForm'],
    },
    {
      label: 'Jurisdiction',
      key: ['controller_jurisdiction', 'controllerJurisdiction', 'controller_jurisdiction_cd'],
    },
    {
      label: 'Statute',
      key: ['controller_incorporation_statute', 'controllerIncorporationStatute', 'incorporationStatute'],
    },
    {
      label: 'Corporate Entity Register',
      key: ['controller_register_name', 'controllerRegisterName', 'corporateEntityRegister'],
    },
    {
      label: 'Registration No (Foreign Register)',
      key: ['controller_registration_no', 'controllerRegistrationNo', 'nonAcrAuen', 'nonRegNo'],
    },
    {
      label: 'Date became controller',
      key: [
        'controller_became_date',
        'controllerBecameDate',
        'dateOfBecoming',
        'dateOfAppointed',
      ],
    },
  ],
};

registerRegisterDetail('B32107', noticeCorporateControllerDetailMap);
registerRegisterDetail('B32007', noticeCorporateControllerDetailMap);
